// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"12674f71","481":"45f028a3","673":"89608c76","687":"612dd1e1"}[chunkId] + ".chunk.js";
};